import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ReunioesService } from "../services/reunioes.service";

@Injectable({
  providedIn: 'root'
})
export class ReunioesResolver implements Resolve<boolean> {

  constructor(private service: ReunioesService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReunioesCombosResolver implements Resolve<boolean> {

  constructor(private service: ReunioesService) { }

  resolve(): Observable<any> {
    return this.service.getListCombos();
  }
}